import Vue from 'vue';
import { MeetingsStoreFacade } from './facades/meetings-store.facade';
import { MeetingsService } from './services/meetings.service';

export class MeetingsModule extends Vue {

  Store = new MeetingsStoreFacade();
  Services = MeetingsService;

}
